// <auto-generated>
// Code generated by EDHC (R) Code Generator.
// Changes may cause incorrect behavior and will be lost if the code is
// regenerated.
// Hash: 715646624
// </auto-generated>
import {
  StringLength,
  RegularExpression,
  Required,
  EmailAddress,
  MinValue,
} from 'carehub-shared/validators';
import { Client } from '../../models/client/client';
import { Demographic } from '../../models/member/demographic';
import { Contact } from '../../models/client/contact';
import { ThirdPartyOrg } from '../../models/client/thirdpartyorg';
import { MobileData } from '../../models/member/mobiledata';

export class Member {
  @Required()
  memberId: string;
  @Required()
  clientId: string;
  parentId: string;
  relationshipTypeId: number;
  thirdPartyContactId: string;
  thirdPartyOrgId: string;
  @Required()
  eligibilityTypeId: number;
  languageId: number;
  contactMethodId: number;
  @Required()
  statusId: number;
  activeDate: Date | string;
  @StringLength(50)
  department: string;
  @StringLength(50)
  district: string;
  @StringLength(50)
  division: string;
  dob: Date | string;
  effectiveDate: Date | string;
  @StringLength(50)
  employerSuppliedAccessCode: string;
  @StringLength(50)
  employeeNumber: string;
  @StringLength(256)
  firstName: string;
  @StringLength(6)
  gender: string;
  hireDate: Date | string;
  @Required()
  isDoNotCall: boolean;
  isVip: boolean;
  @Required()
  isProblematic: boolean;
  @StringLength(512)
  problematicNotes: string;
  @StringLength(256)
  lastName: string;
  @StringLength(256)
  middleName: string;
  @StringLength(256)
  preferredName: string;
  @StringLength(50)
  prefix: string;
  @StringLength(50)
  region: string;
  @StringLength(50)
  @RegularExpression(/^\d{3}-?\d{2}-?\d{4}$/, 'invalid ssn')
  ssn: string;
  @StringLength(50)
  suffix: string;
  @StringLength(50)
  surgeryPlusMemberId: string;
  surgeryPlusMemberKey: number;
  terminationDate: Date | string;
  @StringLength(150)
  workLocation: string;
  @StringLength(60)
  groupNumber: string;
  inactiveDate: Date | string;
  createdUserId: string;
  updatedUserId: string;
  createdDate: Date | string;
  updatedDate: Date | string;
  @StringLength(50)
  supplementalId: string;
  planSponsorId: string;
  @StringLength(50)
  @RegularExpression(/^[a-zA-Z0-9]*$/, 'letters or numeric values only')
  subscriptionNumber: string;
  client: Client;
  demographic: Demographic;
  thirdPartyContact: Contact;
  thirdPartyOrg: ThirdPartyOrg;
  mobileData: MobileData;
}

export function initializeNewMember(): Member {
  const instance = new Member();
  instance.memberId = '00000000-0000-0000-0000-000000000000';
  instance.clientId = '00000000-0000-0000-0000-000000000000';
  instance.parentId = '00000000-0000-0000-0000-000000000000';
  instance.relationshipTypeId = null;
  instance.thirdPartyContactId = '00000000-0000-0000-0000-000000000000';
  instance.thirdPartyOrgId = '00000000-0000-0000-0000-000000000000';
  instance.eligibilityTypeId = null;
  instance.languageId = null;
  instance.contactMethodId = null;
  instance.statusId = null;
  instance.activeDate = null;
  instance.department = '';
  instance.district = '';
  instance.division = '';
  instance.dob = null;
  instance.effectiveDate = null;
  instance.employerSuppliedAccessCode = '';
  instance.employeeNumber = '';
  instance.firstName = '';
  instance.gender = '';
  instance.hireDate = null;
  instance.isDoNotCall = false;
  instance.isVip = false;
  instance.isProblematic = false;
  instance.problematicNotes = '';
  instance.lastName = '';
  instance.middleName = '';
  instance.preferredName = '';
  instance.prefix = '';
  instance.region = '';
  instance.ssn = '';
  instance.suffix = '';
  instance.surgeryPlusMemberId = '00000000-0000-0000-0000-000000000000';
  instance.surgeryPlusMemberKey = null;
  instance.terminationDate = null;
  instance.workLocation = '';
  instance.groupNumber = '';
  instance.inactiveDate = null;
  instance.createdUserId = '00000000-0000-0000-0000-000000000000';
  instance.updatedUserId = '00000000-0000-0000-0000-000000000000';
  instance.createdDate = null;
  instance.updatedDate = null;
  instance.supplementalId = '00000000-0000-0000-0000-000000000000';
  instance.planSponsorId = '00000000-0000-0000-0000-000000000000';
  instance.subscriptionNumber = '';
  instance.client = null;
  instance.demographic = null;
  instance.thirdPartyContact = null;
  instance.thirdPartyOrg = null;
  instance.mobileData = null;
  return instance;
}
